import { useMemo } from "react";
import { useLocale } from "@src/packages/i18n/useLocale";
import { makeTFunc } from "@src/packages/i18n/translations";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

/** Feature-scoped catalogues keep national-estimator copy with its consumers. */
export function useClinicIVFTranslations() {
  const { locale } = useLocale();
  return useMemo(() => makeTFunc(locale === "fr" ? fr : en), [locale]);
}
